
export const name = 'message-api-config'
export const api = {
  message: {
    list: `/api/v2/agent/msg/pageByUser`, // get
    detail: `/api/v2/agent/msg/info`, // get
    read: `/api/v2/agent/msg/read/:id`, // get
    setPassword: `/api/v2/agent/isv/box/set/password`,
    getMessageList: `/api/v2/agent/msg/notification-page` // post 查询小铃铛消息
  },
  todo: {
    getTodoList: `/api/v2/agent/todo/page`, // post 查询待办列表
    getTicketLogistics: `/api/v2/agent/purchaser/we-chat/ticket-logistics`, // get 待办发票数量统计
    getTicketPageByIds: `/api/v2/agent/purchaser/we-chat/ticketPageByIds`, // post 待办票据列表
    relateLogistics: `/api/v2/agent/purchaser/we-chat/relateLogistics`, // post 关联快递单
    markSend: `/api/v2/agent/purchaser/we-chat/markSend`, // post 电票标记已发送
    updateById: `/api/v2/agent/todo/update-by-id` // post 待办标记已处理
  },
  logistics: {
    getMatchShipper: `/api/v2/agent/invoice/match-shipper`, // get 根据快递单号识别快递公司信息
    getshipperNameList: `/api/v2/agent/invoice/list-shipper` // get 根据快递单号识别快递公司信息
  },
  notice: {
    getNoticeList: `/api/v2/bud/notice/list` // post
  }
}
